import { NgModule } from 'ng-metadata/core';
import {PrmLoginItem} from './loginItem/loginItem.directive';
import {LoginHelpService} from './loginHelp/loginHelp.service';
import {PrmLoginHelp} from './loginHelp/loginHelp.directive';
import {LoginService} from './login.service';
import {PrmLogin} from './login.directive';
import {PrmStandAloneLogin} from './standAloneLogin.directive';
import {PrmUnionCatalogLogin} from "./unionCatalogLogin/unionCatalogLogin.directive";
import {PrmUnionCatalogLoginInstitutionItem} from "./unionCatalogLogin/unionCatalogLoginInstitutionItem/unionCatalogLoginInstitutionItem.directive";
import {UnionCatalogLoginService} from "./unionCatalogLogin/unionCatalogLogin.service";

@NgModule({
    declarations: [
        PrmLogin,
        PrmLoginHelp,
        PrmLoginItem,
        PrmStandAloneLogin,
        PrmUnionCatalogLogin,
        PrmUnionCatalogLoginInstitutionItem
    ],
    providers: [
        LoginHelpService,
        LoginService,
        UnionCatalogLoginService
    ],
    imports:[
    ]
})

export class LoginModule{}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/login.module.ts